// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__m6_tP","desktopTable":"styles_desktopTable__AWvxF","responsiveTable":"styles_responsiveTable__GYxiD","table":"styles_table__5x1pF"};